'use strict';

/*
  city -> this field is used for featuredVenue
  name -> this field is used to display name on frontend
  premiumCity -> this field is used to set city free/pro
  slug -> this field is used for URL
  value -> this field is used to store city in database
  sfdcValue -> this field is user to store city in SFDC
*/

module.exports = [{
  city: 'Atlanta,GA,United States',
  name: 'Atlanta',
  premiumCity: false,
  slug: 'Atlanta',
  value: 'Atlanta',
  sfdcValue: 'Atlanta, GA',
  timezone: 'America/New_York',
  cityCode: 'ATL'
}, {
  city: 'Austin,TX,United States',
  name: 'Austin',
  premiumCity: true,
  slug: 'Austin',
  value: 'Austin',
  sfdcValue: 'Austin, TX',
  timezone: 'America/Chicago',
  cityCode: 'AUS'
}, {
  city: 'Baltimore, MD, United States',
  name: 'Baltimore',
  premiumCity: true,
  slug: 'Baltimore',
  value: 'Baltimore',
  sfdcValue: 'Baltimore, MD',
  timezone: 'America/New_York',
  cityCode: 'BAL'
}, {
  city: 'Big Sur, CA, United States',
  name: 'Big Sur',
  premiumCity: true,
  slug: 'Big-Sur',
  value: 'Big Sur',
  sfdcValue: 'Big Sur, CA',
  timezone: 'America/Los_Angeles',
  cityCode: 'BIG'
}, {
  city: 'Boise, ID, United States',
  name: 'Boise',
  premiumCity: true,
  slug: 'Boise',
  value: 'Boise',
  sfdcValue: 'Boise, ID',
  timezone: 'America/Boise',
  cityCode: 'BOI'
}, {
  city: 'Boston,MA,United States',
  name: 'Boston',
  premiumCity: false,
  slug: 'Boston',
  value: 'Boston',
  sfdcValue: 'Boston, MA',
  timezone: 'America/New_York',
  cityCode: 'BOS'
}, {
  city: 'Charleston, SC, United States',
  name: 'Charleston',
  premiumCity: true,
  slug: 'Charleston',
  value: 'Charleston',
  sfdcValue: 'Charleston, SC',
  timezone: 'America/New_York',
  cityCode: 'CHL'
}, {
  city: 'Charlotte, NC, United States',
  name: 'Charlotte',
  premiumCity: true,
  slug: 'Charlotte',
  value: 'Charlotte',
  sfdcValue: 'Charlotte, NC',
  timezone: 'America/New_York',
  cityCode: 'CHA'
}, {
  city: 'Chicago,IL,United States',
  name: 'Chicago',
  premiumCity: false,
  slug: 'Chicago',
  value: 'Chicago',
  sfdcValue: 'Chicago, IL',
  timezone: 'America/Chicago',
  cityCode: 'CHI'
}, {
  city: 'Cleveland, OH, United States',
  name: 'Cleveland',
  premiumCity: true,
  slug: 'Cleveland',
  value: 'Cleveland',
  sfdcValue: 'Cleveland, OH',
  timezone: 'America/New_York',
  cityCode: 'CLE'
}, {
  city: 'Columbus, OH, United States',
  name: 'Columbus',
  premiumCity: true,
  slug: 'Columbus',
  value: 'Columbus',
  sfdcValue: 'Columbus, OH',
  timezone: 'America/New_York',
  cityCode: 'COL'
}, {
  city: 'Dallas,TX,United States',
  name: 'Dallas',
  premiumCity: false,
  slug: 'Dallas',
  value: 'Dallas',
  sfdcValue: 'Dallas, TX',
  timezone: 'America/Chicago',
  cityCode: 'DAL'
}, {
  city: 'Denver,CO,United States',
  name: 'Denver',
  premiumCity: false,
  slug: 'Denver',
  value: 'Denver',
  sfdcValue: 'Denver, CO',
  timezone: 'America/Denver',
  cityCode: 'DEN'
}, {
  city: 'Detroit,MI, United States',
  name: 'Detroit',
  premiumCity: true,
  slug: 'Detroit',
  value: 'Detroit',
  sfdcValue: 'Detroit, MI',
  timezone: 'America/Detroit',
  cityCode: 'DET'
}, {
  city: 'Honolulu, HI, United States',
  name: 'Honolulu',
  premiumCity: false,
  slug: 'Honolulu',
  value: 'Honolulu',
  sfdcValue: 'Honolulu, HI',
  timezone: 'Pacific/Honolulu',
  cityCode: 'HNL'
}, {
  city: 'Houston,TX,United States',
  name: 'Houston',
  premiumCity: false,
  slug: 'Houston',
  value: 'Houston',
  sfdcValue: 'Houston, TX',
  timezone: 'America/Chicago',
  cityCode: 'HOU'
}, {
  city: 'Indianapolis, IN, United States',
  name: 'Indianapolis',
  premiumCity: true,
  slug: 'Indianapolis',
  value: 'Indianapolis',
  sfdcValue: 'Indianapolis, IN',
  timezone: 'America/Indianapolis',
  cityCode: 'IND'
}, {
  city: 'Las Vegas,NV,United States',
  name: 'Las Vegas',
  premiumCity: false,
  slug: 'Las-Vegas',
  value: 'Las Vegas',
  sfdcValue: 'Las Vegas, NV',
  timezone: 'America/Los_Angeles',
  cityCode: 'LV'
}, {
  city: 'Liverpool, England, United Kingdom',
  name: 'Liverpool',
  premiumCity: true,
  slug: 'Liverpool',
  value: 'Liverpool',
  sfdcValue: 'Liverpool, England',
  timezone: 'Europe/London',
  cityCode: 'LPL'
}, {
  city: 'London,England,United Kingdom',
  name: 'London',
  premiumCity: true,
  slug: 'London',
  value: 'London',
  sfdcValue: 'London, England',
  timezone: 'Europe/London',
  cityCode: 'LON'
}, {
  city: 'Los Angeles,CA,United States',
  name: 'Los Angeles',
  premiumCity: false,
  slug: 'Los-Angeles',
  value: 'Los Angeles',
  sfdcValue: 'Los Angeles, CA',
  timezone: 'America/Los_Angeles',
  cityCode: 'LA'
}, {
  city: 'Miami,FL,United States',
  name: 'Miami',
  premiumCity: false,
  slug: 'Miami',
  value: 'Miami',
  sfdcValue: 'Miami, FL',
  timezone: 'America/New_York',
  cityCode: 'MIA'
}, {
  city: 'Milwaukee, WI, United States',
  name: 'Milwaukee',
  premiumCity: true,
  slug: 'Milwaukee',
  value: 'Milwaukee',
  sfdcValue: 'Milwaukee, WI',
  timezone: 'America/Chicago',
  cityCode: 'MIL'
}, {
  city: 'Minneapolis, MN, United States',
  name: 'Minneapolis',
  premiumCity: true,
  slug: 'Minneapolis',
  value: 'Minneapolis',
  sfdcValue: 'Minneapolis, MN',
  timezone: 'America/Chicago',
  cityCode: 'MIN'
}, {
  city: 'Nashville,TN,United States',
  name: 'Nashville',
  premiumCity: false,
  slug: 'Nashville',
  value: 'Nashville',
  sfdcValue: 'Nashville, TN',
  timezone: 'America/Chicago',
  cityCode: 'NASH'
}, {
  city: 'New Orleans, LA, United States',
  name: 'New Orleans',
  premiumCity: true,
  slug: 'New-Orleans',
  value: 'New Orleans',
  sfdcValue: 'New Orleans, LA',
  timezone: 'America/Chicago',
  cityCode: 'NOLA'
}, {
  city: 'New York,NY,United States',
  name: 'New York',
  premiumCity: false,
  slug: 'New-York',
  value: 'New York',
  sfdcValue: 'New York, NY',
  timezone: 'America/New_York',
  cityCode: 'NYC'
}, {
  city: 'Orlando, FL, United States',
  name: 'Orlando',
  premiumCity: false,
  slug: 'Orlando',
  value: 'Orlando',
  sfdcValue: 'Orlando, FL',
  timezone: 'America/New_York',
  cityCode: 'ORL'
}, {
  city: 'Park City, UT, United States',
  name: 'Park City',
  premiumCity: true,
  slug: 'Park-City',
  value: 'Park City',
  sfdcValue: 'Park City, UT',
  timezone: 'America/Denver',
  cityCode: 'PARK'
}, {
  city: 'Philadelphia, PA, United States',
  name: 'Philadelphia',
  premiumCity: false,
  slug: 'Philadelphia',
  value: 'Philadelphia',
  sfdcValue: 'Philadelphia, PA',
  timezone: 'America/New_York',
  cityCode: 'PHI'
}, {
  city: 'Phoenix, AZ, United States',
  name: 'Phoenix/Scottsdale',
  premiumCity: true,
  slug: 'Phoenix',
  value: 'Phoenix',
  sfdcValue: 'Phoenix, AZ',
  timezone: 'America/Phoenix',
  cityCode: 'PHX'
}, {
  city: 'Pittsburgh, PA, United States',
  name: 'Pittsburgh',
  premiumCity: false,
  slug: 'Pittsburgh',
  value: 'Pittsburgh',
  sfdcValue: 'Pittsburgh, PA',
  timezone: 'America/New_York',
  cityCode: 'PIT'
}, {
  city: 'Portland ME, ME, United States',
  name: 'Portland, ME',
  premiumCity: true,
  slug: 'Portland-ME',
  value: 'Portland ME',
  sfdcValue: 'Portland, ME',
  timezone: 'America/Los_Angeles',
  cityCode: 'PME'
}, {
  city: 'Portland OR, OR, United States',
  name: 'Portland, OR',
  premiumCity: true,
  slug: 'Portland-OR',
  value: 'Portland OR',
  sfdcValue: 'Portland, OR',
  timezone: 'America/Los_Angeles',
  cityCode: 'POR'
}, {
  city: 'Raleigh, NC, United States',
  name: 'Raleigh/Durham',
  premiumCity: true,
  slug: 'Raleigh',
  value: 'Raleigh',
  sfdcValue: 'Raleigh, NC',
  timezone: 'America/New_York',
  cityCode: 'RDU'
}, {
  city: 'Sacramento, CA, United States',
  name: 'Sacramento',
  premiumCity: true,
  slug: 'Sacramento',
  value: 'Sacramento',
  sfdcValue: 'Sacramento, CA',
  timezone: 'America/Los_Angeles',
  cityCode: 'SAC'
}, {
  city: 'Salt Lake City, UT, United States',
  name: 'Salt Lake City',
  premiumCity: false,
  slug: 'Salt-Lake-City',
  value: 'Salt Lake City',
  sfdcValue: 'Salt Lake City, UT',
  timezone: 'America/Denver',
  cityCode: 'SLC'
}, {
  city: 'San Antonio, TX, United States',
  name: 'San Antonio',
  premiumCity: true,
  slug: 'San-Antonio',
  value: 'San Antonio',
  sfdcValue: 'San Antonio, TX',
  timezone: 'America/Chicago',
  cityCode: 'SAT'
}, {
  city: 'San Diego,CA,United States',
  name: 'San Diego',
  premiumCity: false,
  slug: 'San-Diego',
  value: 'San Diego',
  sfdcValue: 'San Diego, CA',
  timezone: 'America/Los_Angeles',
  cityCode: 'SD'
}, {
  city: 'San Francisco,CA,United States',
  name: 'San Francisco',
  premiumCity: false,
  slug: 'San-Francisco',
  value: 'San Francisco',
  sfdcValue: 'San Francisco, CA',
  timezone: 'America/Los_Angeles',
  cityCode: 'SF'
}, {
  city: 'San Juan, San Juan, Puerto Rico',
  name: 'San Juan',
  premiumCity: true,
  slug: 'San-Juan',
  value: 'San Juan',
  sfdcValue: 'San Juan, PR',
  timezone: 'America/Puerto_Rico',
  cityCode: 'SJU'
}, {
  city: 'Seattle, WA, United States',
  name: 'Seattle',
  premiumCity: false,
  slug: 'Seattle',
  value: 'Seattle',
  sfdcValue: 'Seattle, WA',
  timezone: 'America/Los_Angeles',
  cityCode: 'SEA'
}, {
  city: 'Sedona, AZ, United States',
  name: 'Sedona',
  premiumCity: true,
  slug: 'Sedona',
  value: 'Sedona',
  sfdcValue: 'Sedona, AZ',
  timezone: 'America/Phoenix',
  cityCode: 'SED'
}, {
  city: 'St. Louis, MO, United States',
  name: 'St. Louis',
  premiumCity: false,
  slug: 'St.-Louis',
  value: 'St. Louis',
  sfdcValue: 'St. Louis, MO',
  timezone: 'America/Chicago',
  cityCode: 'STL'
}, {
  city: 'Tampa, FL, United States',
  name: 'Tampa',
  premiumCity: true,
  slug: 'Tampa',
  value: 'Tampa',
  sfdcValue: 'Tampa, FL',
  timezone: 'America/New_York',
  cityCode: 'TAM'
}, {
  city: 'Washington DC,DC,United States',
  name: 'Washington, D.C.',
  premiumCity: false,
  slug: 'Washington-DC',
  value: 'Washington DC',
  sfdcValue: 'Washington, DC',
  timezone: 'America/New_York',
  cityCode: 'WDC'
}];